export default __webpack_public_path__ + "static/media/market.71fcd54a.png";